import actions from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-contact/actions';

export default () => ({
    state: {},
    actions: {
        ...actions,
    },
});